// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageUploadDragger_wrapper__3r7nE"};